import { all, fork } from "redux-saga/effects";
import AuthSaga from "./auth/saga";
import ClientSaga from "./client/saga";
import ActionSaga from "./action/saga";
import AdminSaga from "./admin/saga";
import ManagerSaga from "./manager/saga";
import StatsSaga from "./stats/saga";
import RandomCoffeeSaga from "./randomCoffee/saga";
import RealTimeSaga from "./realTime/sagas";
import PollSaga from "./poll/saga";
import TokenSaga from "./token/sagas";

export default function* rootSagas() {
  yield all([
    AuthSaga(),
    ClientSaga(),
    ActionSaga(),
    AdminSaga(),
    ManagerSaga(),
    RealTimeSaga(),
    StatsSaga(),
    RandomCoffeeSaga(),
    PollSaga(),
    TokenSaga()
  ]);
}
